export const SIZES_GET_REQUEST = "@sizes.get.request";
export const SIZES_GET_SUCCESS = "@sizes.get.success";
export const SIZES_GET_FAIL = "@sizes.get.failure";
